import { createRouter, createWebHistory, RouterView } from "vue-router";

/**
 * 根据后台菜单数据动态生成路由
 * @param {Array} data 菜单数据
 * @returns {Array} 动态路由数组
 */
export const generateRoutes = (data) => {
  const fmRoutes = [];

  data.forEach((item) => {
    const {
      id,
      menuName,
      path,
      icon,
      hidden,
      name,
      component,
      redirect,
      visible,
      children = [],
    } = item;

    // if (visible == 1) return; // 如果 visible = 1，则不生成路由
    const fmRouter = {
      path: component ? path : "",
      name: name,
      redirect: redirect || undefined,
      meta: {
        icon,
        name: menuName,
        hidden: visible == 1, // ← 如果 visible = 1，则隐藏路由
        menuId: id,
      },

      // 动态加载组件，如果没有组件则使用 RouterView 占位
      component:
        children.length > 0
          ? ""
          : component
          ? (() => {
              let compPath = component;
              if (compPath.endsWith(".vue"))
                compPath = compPath.replace(/\.vue$/, "");

              return () => import("@/views" + compPath + ".vue");
            })()
          : RouterView,

      // 递归生成子路由
      children: children && children.length > 0 ? generateRoutes(children) : [],
    };

    fmRoutes.push(fmRouter);
  });

  return fmRoutes;
};

/**
 * 重置路由
 * @param {Router} router Vue Router 实例
 * @param {Array} data 后台返回的动态路由数据
 */
export const resetRouter = (router, data) => {
  // 生成新的路由
  const routes = [
    {
      path: "/",
      component: () => import("@/views/Main.vue"),
      redirect: "/dashboard",
      children: data,
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
    },
  ];

  // 移除原有路由（除 login 路由）
  router.getRoutes().forEach((r) => {
    if (r.name && r.name !== "login") {
      router.removeRoute(r.name);
    }
  });

  // 动态添加新的路由
  routes.forEach((r) => router.addRoute(r));
};

// 初始化 Vue Router
const router = createRouter({
  history: createWebHistory(), // HTML5 History 模式
  routes: [], // 初始为空，后续动态添加
});

export default router;
